"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ScrollToTop extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "componentDidMount", () => window.scrollTo(0, 0));
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    });
    _defineProperty(this, "render", () => {
      return this.props.children;
    });
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(ScrollToTop);
module.exports = exports.default;